import React, { useEffect, useState } from "react";
import { Formik, Field, FieldArray } from "formik";
import Swal from "sweetalert2";
import Breadcrums from "../../../common/breadcrumbs";
import ColorPalettePicker from "../../../common/colorPalettePicker";
import {
    handleServerValidations,
} from "../../../../../utils/commonfunction";
import { SWAL_SETTINGS } from "../../../../../utils/Constants";
import { useTranslation } from "react-i18next";
import * as Yup from 'yup';
import * as productAttributeManagement from "../../../services/productAttributeManagement";
import * as productManagement from "../../../services/productManagement";
import { useNavigate, useParams } from "react-router-dom";
import { Loader } from "rsuite";

const EditAttributes = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const [submitClicked, setSubmitClicked] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [showdefault, setShowDefault] = useState({});
    const [categories, setCategories] = useState([]);
    const [groupings, setGroupings] = useState([]);

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        {
            title: "Attributes",
            url: "/admin/productManagement/attributes/list/1",
        },
        { title: t("Edit"), url: "" },
    ];

    useEffect(() => {
        productManagement.List({ page: 1, per_page: 1000 }).then(res => {
            if (res.success) setCategories(res.data.list);
        });
        productManagement.GroupingList({ page: 1, per_page: 1000 }).then(res => {
            if (res.success) setGroupings(res.data.list);
        });

        productAttributeManagement
            .Details(params.id)
            .then((response) => {
                setShowDefault(response && response.data ? response.data : []);
                setTimeout(() => {
                    setDataLoaded(true);
                }, 100);
            })
            .catch((error) => {
                console.error("error=====>", error);
            });
    }, [params.id]);

    const validationSchema = Yup.object().shape({
        
        name: Yup.string()
            .trim()
            .required("Attribute name is required")
            .max(100, "Attribute name must be less than 100 characters"),
        description: Yup.string()
            .trim()
            .required("Description is required"),
        attributeType: Yup.string()
            .required("Attribute type is required")
            .oneOf(['text', 'number', 'user_input'], "Invalid attribute type"),

        values: Yup.array().when('attributeType', {
            is: (type) => ['select', 'checkbox', 'radio'].includes(type),
            then: (schema) => schema.min(1, 'At least one value is required for this type'),
            otherwise: (schema) => schema.notRequired()
        })
    });

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {dataLoaded ? (
                <Formik
                    validateOnChange={true}
                    enableReinitialize
                    initialValues={{
                        
                        categoryId: showdefault && showdefault.categoryId 
                            ? (typeof showdefault.categoryId === 'object' ? showdefault.categoryId._id || "" : showdefault.categoryId) 
                            : "",
                        groupingId: showdefault && showdefault.groupingId 
                            ? (typeof showdefault.groupingId === 'object' ? showdefault.groupingId._id || "" : showdefault.groupingId) 
                            : "",
                        name: showdefault && showdefault.name ? showdefault.name : "",
                        description: showdefault && showdefault.description ? showdefault.description : "",
                        attributeType: showdefault && showdefault.attributeType ? showdefault.attributeType : "text",
                        isMultiSelect: showdefault && showdefault.isMultiSelect ? true : false,
                        isVisibleInFilter: showdefault && showdefault.isVisibleInFilter ? true : false,
                        hasColorCode: showdefault && showdefault.hasColorCode ? true : false,
                        values: showdefault && showdefault.values ? showdefault.values.map(v => {
                            if (showdefault.hasColorCode) {
                                return typeof v === 'object' && v !== null ? v : { name: v, colorCode: '#000000' };
                            }
                            return typeof v === 'object' && v !== null ? v.name : v;
                        }) : [""]
                    }}

                    validationSchema={validationSchema}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        setSubmitClicked(true);
                        const formData = new FormData();
                        formData.append("_id", params.id);
                        
                        formData.append("categoryId", values.categoryId || "");
                        formData.append("groupingId", values.groupingId || "");
                        formData.append("name", values.name);
                        formData.append("description", values.description);
                        formData.append("attributeType", values.attributeType);
                        formData.append("isMultiSelect", values.isMultiSelect);
                        formData.append("isVisibleInFilter", values.isVisibleInFilter);
                        formData.append("hasColorCode", values.hasColorCode);
                        formData.append("values", JSON.stringify(values.values.filter(v => typeof v === 'string' ? v.trim() : (v.name && v.name.trim()))));


                        productAttributeManagement.Edit(formData).then((response) => {
                            setSubmitClicked(false);
                            if (response.success) {
                                Swal.fire({
                                    icon: "success",
                                    text: response.message,
                                    ...SWAL_SETTINGS,
                                });
                                setTimeout(() => {
                                    navigate("/admin/productManagement/attributes/list/1");
                                }, 500);
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    text: handleServerValidations(response),
                                    ...SWAL_SETTINGS,
                                });
                            }
                        }).catch((err) => {
                            setSubmitClicked(false);
                            Swal.fire({
                                icon: "error",
                                text: "Error updating attribute",
                                ...SWAL_SETTINGS,
                            });
                        });
                    }}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                        <form onSubmit={handleSubmit} noValidate>
                            <div className="row row-sm">
                                <div className="col-lg-12 col-md-12 animation_fade">
                                    <div className="card custom-card">
                                        <div className="card-body">
                                            <h6 className="main-content-label mb-3">Edit Attribute</h6>

                                            <div className="row row-sm">


                                            <div className="col-md-12 text-center form-group">
                                                <label htmlFor="name" className="text-left d-flex">
                                                    Attribute Name: <span className="requirestar">*</span>
                                                </label>
                                                <input
                                                    name="name"
                                                    id="name"
                                                    type="text"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.name}
                                                    className="form-control"
                                                    placeholder="Enter attribute name"
                                                />
                                                <span className="text-danger d-flex text-left">
                                                    {errors.name && touched.name && errors.name}
                                                </span>
                                            </div>

                                            <div className="col-md-12 text-center form-group">
                                                <label htmlFor="categoryId" className="text-left d-flex">
                                                    Category: <small className="ms-2 text-muted mt-1">(Optional)</small>
                                                </label>
                                                <select
                                                    name="categoryId"
                                                    id="categoryId"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.categoryId}
                                                    className="form-control"
                                                >
                                                    <option value="">Select Category</option>
                                                    {categories?.map((cat) => (
                                                        <option key={cat._id} value={cat._id}>
                                                            {cat.title}
                                                        </option>
                                                    ))}
                                                </select>
                                                <span className="text-danger d-flex text-left">
                                                    {errors.categoryId && touched.categoryId && errors.categoryId}
                                                </span>
                                            </div>

                                            <div className="col-md-12 text-center form-group">
                                                <label htmlFor="groupingId" className="text-left d-flex">
                                                    Grouping: <small className="ms-2 text-muted mt-1">(Optional)</small>
                                                </label>
                                                <select
                                                    name="groupingId"
                                                    id="groupingId"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.groupingId}
                                                    className="form-control"
                                                >
                                                    <option value="">Select Grouping</option>
                                                    {groupings?.map((grp) => (
                                                        <option key={grp._id} value={grp._id}>
                                                            {grp.title}
                                                        </option>
                                                    ))}
                                                </select>
                                                <span className="text-danger d-flex text-left">
                                                    {errors.groupingId && touched.groupingId && errors.groupingId}
                                                </span>
                                            </div>

                                             <div className="col-md-12 text-center form-group"> 
                                                <label htmlFor="attributeType" className="text-left d-flex">
                                                    Attribute Type: <span className="requirestar">*</span>
                                                </label>
                                                <select
                                                    name="attributeType"
                                                    id="attributeType"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.attributeType}
                                                    className="form-control"
                                                >
                                                    <option value="">Select Type</option>
                                                    <option value="text">Text</option>
                                                    <option value="number">Numeric value</option>
                                                    <option value="user_input">Predefined value</option>
                                                </select>
                                                <span className="text-danger d-flex text-left">
                                                    {errors.attributeType && touched.attributeType && errors.attributeType}
                                                </span>
                                            </div>

                                            {values.attributeType === 'user_input' && (
                                                <div className="col-md-12 form-group">
                                                    <label className="text-left d-flex font-weight-bold">
                                                        Attribute Interaction:
                                                    </label>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <input
                                                            name="isMultiSelect"
                                                            id="isMultiSelect"
                                                            type="checkbox"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            checked={values.isMultiSelect}
                                                            style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                                        />
                                                        <label htmlFor="isMultiSelect" className="mb-0 ms-2" style={{ cursor: 'pointer', fontSize: '14px' }}>
                                                            Allow multiple values for this attribute
                                                        </label>
                                                    </div>

                                                    <div className="d-flex align-items-center gap-2 mt-2">
                                                        <input
                                                            name="isVisibleInFilter"
                                                            id="isVisibleInFilter"
                                                            type="checkbox"
                                                            tabIndex={-1}
                                                            onChange={handleChange}
                                                            checked={values.isVisibleInFilter}
                                                            style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                                        />
                                                        <label htmlFor="isVisibleInFilter" className="mb-0 ms-2" style={{ cursor: 'pointer', fontSize: '14px' }}>
                                                            Visible in filter
                                                        </label>
                                                    </div>

                                                    {/* <div className="d-flex align-items-center gap-2 mt-2">
                                                        <input
                                                            name="hasColorCode"
                                                            id="hasColorCode"
                                                            type="checkbox"
                                                            tabIndex={-1}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                                const isChecked = e.target.checked;
                                                                if (isChecked) {
                                                                    const allTabs = [
                                                                        { name: "Neutral", colorCode: "tab:Neutral" },
                                                                        { name: "Dark Shades", colorCode: "tab:Dark Shades" },
                                                                        { name: "Cream / Brown", colorCode: "tab:Cream / Brown" },
                                                                        { name: "Earth", colorCode: "tab:Earth" },
                                                                        { name: "Red", colorCode: "tab:Red" },
                                                                        { name: "Pink", colorCode: "tab:Pink" },
                                                                        { name: "Yellow / Orange", colorCode: "tab:Yellow / Orange" },
                                                                        { name: "Green", colorCode: "tab:Green" },
                                                                        { name: "Teal / Sea", colorCode: "tab:Teal / Sea" },
                                                                        { name: "Blue", colorCode: "tab:Blue" },
                                                                        { name: "Purple", colorCode: "tab:Purple" },
                                                                        { name: "Special", colorCode: "tab:Special" },
                                                                        { name: "Metallic Colours", colorCode: "tab:Metallic Colours" }
                                                                    ];
                                                                    if (values.values.length === 0 || (values.values.length === 1 && (values.values[0] === "" || (typeof values.values[0] === 'object' && !values.values[0].name)))) {
                                                                        setFieldValue('values', allTabs);
                                                                    } else {
                                                                        const newValues = values.values.map(v => {
                                                                            return typeof v === 'string' ? { name: v, colorCode: '#000000' } : v;
                                                                        });
                                                                        setFieldValue('values', newValues);
                                                                    }
                                                                } else {
                                                                    const newValues = values.values.map(v => {
                                                                        return typeof v === 'object' && v !== null ? v.name : v;
                                                                    });
                                                                    setFieldValue('values', newValues);
                                                                }
                                                            }}
                                                            checked={values.hasColorCode}
                                                            style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                                        />
                                                        <label htmlFor="hasColorCode" className="mb-0 ms-2" style={{ cursor: 'pointer', fontSize: '14px' }}>
                                                            Show color picker
                                                        </label>
                                                    </div> */}
                                                </div>
                                            )}





                                            <div className="col-md-12 text-center form-group">
                                                <label htmlFor="description" className="text-left d-flex">
                                                    Description:
                                                </label>
                                                <textarea
                                                    name="description"
                                                    id="description"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.description}
                                                    className="form-control"
                                                    placeholder="Enter description"
                                                />
                                                <span className="text-danger d-flex text-left">
                                                    {errors.description && touched.description && errors.description}
                                                </span>
                                            </div>

                                            <div className="col-md-12 text-center form-group">
                                                {['text', 'number'].includes(values.attributeType) ? null : (
                                                    <>
                                                        <label className="text-left d-flex">
                                                            Predefined Values: <span className="requirestar">*</span>
                                                        </label>
                                                        <FieldArray
                                                            name="values"
                                                            render={(arrayHelpers) => (
                                                                <div>
                                                                    {values.values && values.values.length > 0 ? (
                                                                        values.values.map((v, index) => (
                                                                            <div key={index} className="d-flex mb-2">
                                                                                <input
                                                                                    name={values.hasColorCode ? `values.${index}.name` : `values.${index}`}
                                                                                    value={values.hasColorCode ? v.name : v}
                                                                                    onChange={handleChange}
                                                                                    className="form-control"
                                                                                    placeholder={`Value ${index + 1}`}
                                                                                />
                                                                                {values.hasColorCode && (
                                                                                    <ColorPalettePicker
                                                                                        name={`values.${index}.colorCode`}
                                                                                        value={v.colorCode || '#000000'}
                                                                                        onChange={(e) => {
                                                                                            const val = e.target.value;
                                                                                            setFieldValue(`values.${index}.colorCode`, val);
                                                                                            if (val.startsWith("tab:")) {
                                                                                                const tabName = val.replace("tab:", "");
                                                                                                setFieldValue(`values.${index}.name`, tabName);
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-danger ms-2"
                                                                                    onClick={() => arrayHelpers.remove(index)}
                                                                                >
                                                                                    <i className="ri-delete-bin-line"></i>
                                                                                </button>
                                                                            </div>
                                                                        ))
                                                                    ) : null}
                                                                        <div className="d-flex align-items-center gap-2 mt-2">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-main-primary signbtn d-flex text-xs"
                                                                                onClick={() => arrayHelpers.push(values.hasColorCode ? { name: "", colorCode: "#000000" } : "")}
                                                                            >
                                                                                + Add Value
                                                                            </button>
                                                                            {values.hasColorCode && (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-secondary signbtn d-flex text-xs"
                                                                                    onClick={() => {
                                                                                        const allTabs = [
                                                                                            { name: "Neutral", colorCode: "tab:Neutral" },
                                                                                            { name: "Dark Shades", colorCode: "tab:Dark Shades" },
                                                                                            { name: "Cream / Brown", colorCode: "tab:Cream / Brown" },
                                                                                            { name: "Earth", colorCode: "tab:Earth" },
                                                                                            { name: "Red", colorCode: "tab:Red" },
                                                                                            { name: "Pink", colorCode: "tab:Pink" },
                                                                                            { name: "Yellow / Orange", colorCode: "tab:Yellow / Orange" },
                                                                                            { name: "Green", colorCode: "tab:Green" },
                                                                                            { name: "Teal / Sea", colorCode: "tab:Teal / Sea" },
                                                                                            { name: "Blue", colorCode: "tab:Blue" },
                                                                                            { name: "Purple", colorCode: "tab:Purple" },
                                                                                            { name: "Special", colorCode: "tab:Special" },
                                                                                            { name: "Metallic Colours", colorCode: "tab:Metallic Colours" }
                                                                                        ];
                                                                                        setFieldValue("values", allTabs);
                                                                                    }}
                                                                                >
                                                                                    Auto Select All Tabs
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                </div>
                                                            )}
                                                        />
                                                    </>
                                                )}
                                                <span className="text-danger d-flex text-left">
                                                    {errors.values && touched.values && typeof errors.values === 'string' && errors.values}
                                                </span>
                                            </div>

                                        </div>

                                        <div className="mt-4">
                                            <button
                                                className="btn btn-main-primary signbtn mr-2"
                                                type="submit"
                                                disabled={submitClicked}
                                            >

                                                <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                {t("btn_submit")}
                                            </button>
                                            <button
                                                className="btn ripple btn-dark"
                                                type="button"
                                                onClick={() =>
                                                    navigate("/admin/productManagement/attributes/list/1")
                                                }
                                            >
                                                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                                {t("btn_back")}
                                            </button>
                                        </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
                </Formik>
            ) : (
                <Loader />
            )}
        </>
    );
};

export default EditAttributes;
